var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Subtitles"},_vm._l((_vm.subtitles),function(subtitle){return _c('div',{ref:"subtitle",refInFor:true,staticClass:"Subtitles__text",domProps:{"innerHTML":_vm._s(subtitle)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }